
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Settings } from "lucide-react";
import { ProductDataExport } from "./ProductDataExport";
import { useNavigate } from "react-router-dom";

interface BackendDashboardProps {
  onBack: () => void;
}

export const BackendDashboard = ({ onBack }: BackendDashboardProps) => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-4 md:p-6">
      <div className="flex items-center gap-4 mb-6">
        <Button variant="outline" onClick={onBack} className="flex items-center gap-2">
          <ArrowLeft className="w-4 h-4" />
          Back to Dashboard
        </Button>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Backend Dashboard</h1>
          <p className="text-gray-600">Manage your product data and integrations</p>
        </div>
      </div>
      
      <div className="grid gap-6">
        {/* Quick Access Card */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Settings className="w-5 h-5" />
              Quick Access
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => navigate('/sync-manager')}
                className="flex items-center gap-2"
              >
                <Settings className="w-4 h-4" />
                Square Sync Manager
              </Button>
              <Button 
                variant="outline"
                onClick={() => navigate('/cost-monitor')}
                className="flex items-center gap-2"
              >
                Cost Monitor
              </Button>
            </div>
          </CardContent>
        </Card>

        <ProductDataExport />
      </div>
    </div>
  );
};
